import * as React from 'react'
import Box from '@eversports/klimt-primitives/legacy/Box'

const BannerSectionBadge = ({ children }: React.PropsWithChildren<unknown>) => {
  return <Box sx={{ backgroundColor: 'rgba(20, 20, 20, 0.9)', borderRadius: 1, py: 1, px: 3 }}>{children}</Box>
}

export default BannerSectionBadge
